module.exports = __webpack_public_path__ + "static/media/dummy3.f4cc9da5.jpeg";